import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContextService, ErrorAlertService, XenaClient } from 'src/app/services';
import { ISaveResult } from 'src/app/xena-api';

@Injectable({
  providedIn: 'root'
})
export class BlobFiscalService {

  constructor(private xenaClient: XenaClient,
    private context: ContextService,
    private errorAlertService: ErrorAlertService) { }

  // This method deviates from the standard, because the BlobFiscal endpoint in Xena API wraps errors with 200 status code
  postByType(relationType: string, relationId: number, data: FormData): Observable<ISaveResult> {
    if (relationType === "" || relationType === null) {
      throw new Error('relationType cannot be null or empty');
    }
    const resourcePath: string = `/Blob/Fiscal/${this.context.fiscalId}/${relationType}/${relationId}`;

    return this.xenaClient.post(resourcePath, data).pipe(
      map(r => {
        const response = r[0] as ISaveResult;
        if (response != null && !response.success) {
          this.errorAlertService.showError(response.messages);
          throw new Error(response.messages.join('\r\n'));
        }
        return response;
      })
    );
  }

}
